module.exports = "/dist/b301c4cd6dd23e14ddec9e633ecbb703.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-900italic.eot
// module id = 23
// module chunks = 0